import { IForm } from "types/form";

export const scopes = ["email", "name", "address", "phoneNumber", "birthDate"];

export type ProviderModel = {
    id: number;
    name: string;
    api_key: string;
    access_key: string;
    secret_key: string;
    merchant_number: number;
    settings?: any;
    accounts?: any;
};
export type ProviderModelUpdate = {
    id?: number;
    name?: string;
    is_default?: boolean;
    flag?: string;
    key?: string;
};
export interface IProvidersForm extends IForm {
    data: ProviderModel;
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref: any;
}
export interface IProvidersListProps {
    onClick: Function;
}

export interface IUpdateField {
    item: ProviderModel;
    reload: Function;
}

export default interface IProvidersAll {
    name: string;
    provider: string;
}
